var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 43,
    viewBox: "0 0 40 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.437164,
    width: 40,
    height: 41.7484,
    fill: "url(#pattern0_133_1056)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_133_1056",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_133_1056",
    transform: "matrix(0.0434879 0 0 0.0416667 -0.0218554 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_133_1056",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAnxJREFUSEu11U+MnWMUx/HPue1tibZ0DEntulCiQSZVTfytSLBCQyS2EmXRhIj0z9xpvIl5ZzKRkEgsbEjUhmlsbDRENCIRTBHCsGhaUjQS1AjJXL3HfS+Dcm/v3GT6bp/fe77nec45vxPO8BdnOL7TA/bk9cI24Vpc0kkmzQpvY1oZ7/VLsDtgT16m5gVs6hPggN9tNxVf9dL9H7A3N2l5HWtxXHpKzYzlPuoEmTcibMYjOB/fCjcZjy+6QU4FjOXF0rsYEl7UtMNUnOiaXZFDmp7DHTgqbTERx/+rPRXQyEMYaQOeVsZD/d63c97I/bir/ZyvKuP23oBGVqJKfNiXNpiOk4sCFLlK02FcgM3K+ODf//1zg7F8SbpHeNB4PLuo4AuisSykx4QnjMfO7oDRPCZcpG6dIr4bCLA3R7Qckt43EVd3BzTyN5ylbpkiWgMBilyjqWqGH5Ux1Aswh1XqVivil4EAO3O1up8xp4w1vQCf41ItG03GZwMBRvOK9sR/jE+VcXkvQFXY7dJuEzE1IKAqcFXoZ0zEjl5FvlV4TfrGCusVMb8oyKN5jpWOYFjLVpNxsDvgz6F5B9fgeWXc1x+QoWH6r0E7oIzbTj/JY7leqhxyWHjZcg8o4qceVnGhpn24BcfUXdWtvbuZXdXTb3T8qDI7npRmrPCheSvVXKlli/Awzus8abrZZMz2N7sFxSB2zf3K+NporhP2abnXZHy/EKrfwrlRzZ24DhtwUpiVDqrZ7/GY+TvrRr6Cbe16fKJuqyJ+qM6WbmUWOazprfam24gZdTco4telA1Tp7s61lnmzs4Tq7l56QAXZlec629yCny3tDbq00R/6A8YZVF3zpAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.46e54faa5ea1bed1b0a026014a39f64c.svg";
export { ForwardRef as ReactComponent };